import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import GlobalStyle from './components/GlobalStyle';
import Landing from './pages/Landing';
import { PageTransitionProvider } from './components/PageTransition';

// Route-level code splitting: the landing selector stays tiny and instant;
// each discipline's (much heavier) page loads only once chosen. The loader
// functions are also handed to PageTransitionProvider so it can preload the
// chunk while the transition animation plays, and reused here by lazy().
const loadCoaching = () => import('./pages/CoachingPage');
const loadWeb = () => import('./pages/WebPage');
const CoachingPage = lazy(loadCoaching);
const WebPage = lazy(loadWeb);
const loaders = { coaching: loadCoaching, web: loadWeb };

function App() {
  return (
    <BrowserRouter>
      <GlobalStyle />
      <PageTransitionProvider loaders={loaders}>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/coaching" element={<CoachingPage />} />
            <Route path="/web" element={<WebPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </PageTransitionProvider>
    </BrowserRouter>
  );
}

export default App;
